/** Keep HTML markers screen-aligned (Leaflet-like); map pitch must not skew pins into ovals. */
export const MAPLIBRE_MARKER_VIEWPORT_ALIGNMENT = {
  pitchAlignment: "viewport" as const,
  rotationAlignment: "viewport" as const,
};

/** Station circle radius (px) when stations render as GPU dots. */
export const STATION_DOT_RADIUS_PX = 5;
/** Larger radius (px) for the final stop, mirroring the pin emphasis. */
export const STATION_DOT_LAST_RADIUS_PX = 7;
/** White outline (px) so a station dot stays visible on top of its route line. */
export const STATION_DOT_STROKE_WIDTH_PX = 2;

/**
 * How long a popup lingers after the pointer leaves its marker.
 *
 * Crossing the gap between pin and popup would otherwise shut the popup out from under the cursor, so the
 * close is deferred by this long and cancelled if the pointer lands on the popup. Longer than Leaflet's
 * 120ms because the gap is longer: the popup now clears the pin's number badge (45px up, against Leaflet's
 * ~32px), and at 120ms an unhurried pointer lost the popup before reaching it.
 */
export const MAPLIBRE_HOVER_POPUP_CLOSE_DELAY_MS = 300;

/** MapLibre's class on every HTML marker element it mounts over the canvas. */
export const MAPLIBRE_MARKER_SELECTOR = ".maplibregl-marker";
